/* globals $:false */

import tmpl_field from '../templates/param-form-field.dot';

/*
 * TODO: These ones must get separated in P and V, but maybe after the RecordM migration
 */
var FieldPresenter = function(core, field, parent) {

    var _fieldPs = [],
        _dupPs = [];

    var _visible = true,
        _newlyVisible = true,
        _isRootField = (parent ? false : true);

    var _clone = function () {
        var fieldCopy = _getClone(true, false);

        if (_isRootField) {
            core.publish("reportm:service-root-field-collection-increment-" + field.id, fieldCopy);

        } else {
            core.publish("reportm:field-collection-increment-" + parent.id + "-" + field.id, fieldCopy);
        }
    };

    var _getClone = function(deletable, withValue) {

        var fieldCopy = {
            id : core.locallyUniqueId(),
            key : field.key,
            label : field.label,
            description : field.description,
            duplicable : false,
            fieldType : field.fieldType,
            condition : field.condition,
            options : field.options,
            defaultValue : field.defaultValue,
            deletable : deletable
        };

        if (withValue) fieldCopy.value = view.getValue();

        if (field.fields) fieldCopy.fields = [];
        _fieldPs.forEach(function(el) {
            fieldCopy.fields.push(el.getClone(false, withValue));
        });

        _dupPs.forEach(function(el) {
            el.fillClones(fieldCopy);
        });

        return fieldCopy;
    };

    var view = (function() {
        var _$element = {},
            _$elementValueNode = {};


        var _previousChildrenVisibility = false;

        var _toggleButton = function() {
            if (_$element.children('.js-sub-fields').hasClass("hidden")) {
                _expandFields();
            } else {
                _colapseFields();
            }
        };

        var _addDuplicateButton = function() {
            _clone();
        };

        var _removeDuplicateButton = function() {
            core.publish("reportm:field-collection-decrement-" + field.id, field.id);
        };

        var _expandFields = function() {
            var $elementIcon = _$element.find(".js-toggle-button").first();

            _$element.children(".js-sub-fields").first().removeClass('hidden');
            $elementIcon.html("V");
        };

        var _colapseFields = function() {
            var $elementIcon = _$element.find(".js-toggle-button").first();

            _$element.find(".js-sub-fields").first().addClass('hidden');
            $elementIcon.html(">");
        };

        var _updateChildrenState = function() {
            var updatedChildrenVisibility = _hasChildrenVisible();
            var newlyVisibleChilren = _hasChildrenNewlyVisible();

            if ((updatedChildrenVisibility && !_previousChildrenVisibility) || newlyVisibleChilren) {
                _expandFields();
            } else if (!updatedChildrenVisibility && _previousChildrenVisibility) {
                _colapseFields();
            }

            _previousChildrenVisibility = updatedChildrenVisibility;
        };

        var _getValue = function() {
            return _$elementValueNode.val();
        };

        var _handleFieldExpandBtn = function(){
            var _$expandBtn;

            if(field.fields && field.fields.length > 0){
                _$expandBtn = _$element.find(".js-toggle-button").first();

                if(_$elementValueNode.val()){
                    _$expandBtn.removeClass("hidden");
                }else{
                    _$expandBtn.addClass("hidden");
                }
            }
        };

        return{
            init : function() {
                _$element = $(tmpl_field(field));
                _$elementValueNode = _$element.find("#" + field.id);

                _$elementValueNode.bind('keyup paste change', function() {
                    core.publish('field-value-change-' + field.id, _getValue());

                    _handleFieldExpandBtn();

                    _validateSelf();

                    _updateChildrenState();
                });

                _$elementValueNode.blur(function() {
                    _validateSelf();
                });

                if (field.isDateField) {
                    _$elementValueNode.datepicker({dateFormat:'dd/mm/yy', nextText:'', prevText:''});
                }

                _handleFieldExpandBtn();
            },
            getContainer: function() {
                return _$element;
            },
            addField: function(field) {
                _$element.children(".js-sub-fields").append(field.content());
            },
            addFieldAfter: function(field, afterWhom) {
                $(afterWhom.content()).after(field.content());
            },
            addToggleBehaviour: function() {
                _$element.find(".js-toggle-button").click(_toggleButton);
            },
            addDuplicateBehaviour:function() {
                _$element.find(".js-duplicate-button").click(_addDuplicateButton);
            },
            addRemoveBehaviour: function() {
                _$element.find(".js-remove-button").click(_removeDuplicateButton);
            },
            updateChildrenState: _updateChildrenState,
            expandFields: _expandFields,
            hideSelf: function() {
                _$element.hide();
            },
            showSelf: function() {
                _$element.show();
            },
            markRequiredError: function() {
                var $controlGroup = _$elementValueNode
                        .parents(".js-control-group")
                        .first(),
                    $errorMsgContainer = $(".js-errormsg",_$element).first(),
                    message = core.translateString("reportm", "reports.field.mandatory");

                $controlGroup.addClass("error");

                $errorMsgContainer.html(message);
            },
            clearErrors: function() {
                var $controlGroup = _$elementValueNode
                        .parents(".js-control-group")
                        .first(),
                    $errorMsgContainer = $(".js-errormsg",_$element).first();

                $controlGroup.removeClass("error");

                $errorMsgContainer.html("");
            },
            getValue: _getValue,
            remove:function() {
                _$element.remove();
            }
        }
    }());

    var _extendField = function() {

        if (!field.description) {
            field.description = "";
        }

        //This is only used in the template.
        if (field.fieldType) {

            if (field.fieldType === 'select') {
                field.parsedOptions = field.options ? (/\$\[([^\]]+)\]/).exec(field.options)[1].split(",") : undefined;

            } else if (field.fieldType === 'date') {
                field.isDateField = true;
            }
        }

        field.value = field.defaultValue || '';
    };

    var _satisfiesCondition = function(parentValue) {
        if (!field.condition) return true;

        switch (field.condition.charAt(0)) {
            case '=':
                return parentValue === field.condition.substr(1);
            case '<':
                return parentValue < field.condition.substr(1);
            case '>':
                return parentValue > field.condition.substr(1);
           default:
                throw new Error("unsupported operator " + field.condition.charAt(0))
        }
    };

    var _updateVisibility = function(evt, parentValue) {

        var _currentlyVisible = _satisfiesCondition(parentValue);
        _newlyVisible = _currentlyVisible && !_visible;

        _visible = _currentlyVisible;

        if (_visible) {
            view.showSelf();
        } else {
            view.hideSelf();
        }
    };

    var _hasChildrenVisible = function() {
        var someChildVisible = false;

        _fieldPs.forEach(function(fieldP) {
            someChildVisible = someChildVisible || fieldP.isVisible();
        });

        _dupPs.forEach(function(dupP) {
            someChildVisible = someChildVisible || dupP.isVisible();
        });

        return someChildVisible;
    };

    var _hasChildrenNewlyVisible = function() {
        var someChildNewlyVisible = false;

        _fieldPs.forEach(function(fieldP) {
            someChildNewlyVisible = someChildNewlyVisible || fieldP.isNewlyVisible();
        });

        _dupPs.forEach(function(dupP) {
            someChildNewlyVisible = someChildNewlyVisible || dupP.isNewlyVisible();
        });

        return someChildNewlyVisible;
    };

    var _validateSelf = function() {
        var ok = !_visible || view.getValue() !== '';

        if (ok) {
            view.clearErrors();
        } else {
            view.markRequiredError();
        }

        return ok;
    };

    var _init = function() {

        _extendField();

        view.init();
        if (parent) {
            core.subscribe('field-value-change-' + parent.id, _updateVisibility);
            _updateVisibility(null, parent.value);
        }

        if (field.fields && field.fields.length > 0) {
            view.addToggleBehaviour();

            field.fields.forEach(function(childField) {

                childField.id = core.locallyUniqueId();

                if (childField.duplicable) {
                    _dupPs[field.id] = new DuplicateFieldsPresenter(
                        core,
                        view,
                        childField,
                        {id: field.id}
                    );

                } else {
                    var newFieldP = new FieldPresenter(
                        core,
                        childField,
                        field
                    );
                    _fieldPs.push(newFieldP);
                    view.addField(newFieldP);
                }

            });

            view.updateChildrenState();
        }

        if (field.duplicable) {
            view.addDuplicateBehaviour();

        } else if (field.deletable) {
            view.addRemoveBehaviour();
        }

    };
    _init();

    return {
        getReportId:function() {
            return field.id;
        },
        content: function() {
            return view.getContainer();
        },
        isVisible:function() {
            return _visible;
        },
        isNewlyVisible:function() {
            return _newlyVisible;
        },
        validate: function() {
            if (!_visible) {
                return true;
            }

            var allOk = true;

            _fieldPs.forEach(function(fieldP) {
                allOk = fieldP.validate() && allOk;
            });
            _dupPs.forEach(function(dupP) {
                allOk = dupP.validate() && allOk;
            });

            if (!allOk) view.expandFields();

            return _validateSelf() && allOk;
        },
        getModel: function() {
            return _getClone(false, true);
        },
        getClone:_getClone,
        destroy:view.remove
    }
};

var DuplicateFieldsPresenter = function(core, view, field, parent) {

    var _originalP;
    var _duplicatePs = [];

    var _addDuplicateField = function(event, duplicateField) {
        var newFieldP = new FieldPresenter(core, duplicateField, parent),
            afterWhom = _duplicatePs[_duplicatePs.length - 1];

        _duplicatePs.push(newFieldP);
        if (afterWhom) {
            view.addFieldAfter(newFieldP, afterWhom);
        } else {
            view.addFieldAfter(newFieldP, _originalP);
        }

        core.subscribe("reportm:field-collection-decrement-" + duplicateField.id, _removeDuplicateField);

        //TODO: Isto serve para alguma coisa?
        if (typeof view.getValue === 'function') {
            core.publish('field-value-change-' + parent.id, view.getValue());
        }
    };

    var _removeDuplicateField = function(event, duplicateFieldId) {
        var idx,
            fieldP,
            collLength = _duplicatePs.length;

        for (var i = 0; i < collLength; i++) {
            if (_duplicatePs[i].getReportId() === duplicateFieldId) {
                idx = i;
            }
        }

        fieldP = _duplicatePs[idx];

        fieldP.destroy();
        _duplicatePs = _duplicatePs.slice(0, idx).concat(_duplicatePs.slice(idx + 1));
    };

    var _init = function() {
        _originalP = new FieldPresenter(core, field, parent);
        view.addField(_originalP);

        if (parent) {
            core.subscribe("reportm:field-collection-increment-" + parent.id + "-" + field.id, _addDuplicateField);
        } else {
            core.subscribe("reportm:service-root-field-collection-increment-" + field.id, _addDuplicateField);
        }

    };
    _init();

    return{
        getModel: function() {
            var fieldModels = [];
            fieldModels.push(_originalP.getModel());
            _duplicatePs.forEach(function(el) {
                fieldModels.push(el.getModel());
            });

            return fieldModels;
        },
        isVisible:function() {
            return _originalP.isVisible();
        },
        isNewlyVisible:function() {
            return _originalP.isNewlyVisible();
        },
        validate: function() {
            var allOk = true;

            allOk = _originalP.validate() && allOk;

            _duplicatePs.forEach(function(fieldP) {
                allOk = fieldP.validate() && allOk;
            });

            return allOk;
        },
        fillClones: function(fieldClone) {
            if (fieldClone.fields) {
                fieldClone.fields.push(_originalP.getClone(false));
            }
        }
    }
};

export { DuplicateFieldsPresenter, FieldPresenter };
